//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, destroy, STATUS } from '@/apis/mch'
import moment from 'moment';

export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
            },
            searchQuery: {
                state: '',
                mchName: '',
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            previewVisible: false,
            previewImage: "",
        }
    },
    created() {
        this.columns = [
            { title: '名稱', dataIndex: 'mchName', key: 'mchName', width: 180, },
            { title: '品牌編號', dataIndex: 'mchNo', key: 'mchNo', width: 180, },
            { title: 'Logo',key: 'logo', width: 180, scopedSlots: { customRender: 'imageSlot' } },
            { title: '簡稱', dataIndex: 'mchShortName', key: 'mchShortName', width: 180, },
            { title: '負責人', dataIndex: 'contactName', key: 'contactName', width: 180, },
            { title: '負責人郵箱', dataIndex: 'contactEmail', key: 'contactEmail', width: 180, },
            { title: '負責人手機號', dataIndex: 'contactTel', key: 'contactTel', width: 180, },
            { title: '狀態', key: 'status', width: 100, scopedSlots: { customRender: 'statusSlot' }, },
            { title: '創建時間', dataIndex: 'createdAt', key: 'createdAt', width: 180, },
            { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];



    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(url) {
            this.previewImage = url;
            this.previewVisible = true;
        },
        moment,
        async onPageConfig() {
            try {
                let _status = [];
                Object.keys(STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: STATUS[value]
                    })
                })
                this.config.status = _status;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                res.data.records.forEach(value => { 
                    value.logo = value.logo === undefined ? "" : value.logo;
                })
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getSportTypeName(code) {
            if (code && this.config.motions) {
                const data = this.config.motions.filter(item => item.typeCode == code);
                if (data && data.length > 0) {
                    return data[0].name
                }
            }
            return code;
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },

        //刪除行
        async handleOnDelete(record) {
            try {
                const res = await destroy(record.mchNo);
                if (res.code == 0) {
                    this.$message.success('Delete Success');
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToForm(id) {
            if (id) {
                this.$router.push(`/mch/edit/${id}`);
            } else {
                this.$router.push('/mch/add');
            }

        }
    }
}
